const getters = {

    client_terminal_telemetries: (state) => {
        return state.client_terminal_telemetries;
    },
    client_terminal_rfid_logs: (state) => {
        return state.client_terminal_rfid_logs;
    },
    weaponPool: state => state.WeaponPool,
    weaponPoolStatistics: state => state.WeaponPoolStatistics
};

export default getters;
